import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, NgForm} from '@angular/forms';
import {AppState} from '@app/store/app.states';
import {environment} from '@environments/environment';
import {fuseAnimations} from '@fuse/animations';
import {Store} from '@ngrx/store';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Observable} from 'rxjs';

import {ConnectAs, UpdateUserDetail} from '../store/users-list.actions';
import {UxInteractions} from '../store/users-list.reducers';
import {currentUserDetail, currentUxInteraction} from '../store/users-list.selector';

@Component({
  selector: 'app-fouradmin-user-screen-out-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  animations: fuseAnimations,
})
export class UserDetailsComponent extends OnDestroyMixin implements OnInit {

  @ViewChild('infosForm') infosForm: NgForm;
  private infosFormPluged = false;

  uxInteractions$: Observable<UxInteractions> = this.store.select(currentUxInteraction).pipe(untilComponentDestroyed(this));
  currentUser$: Observable<any> = this.store.select(currentUserDetail).pipe(untilComponentDestroyed(this));

  public localUser: any = null;
  public lastUserId = null;

  baseUrl = environment.legacyBaseUrl;
  avatarUrlExt = environment.bearAvataUrlExtenssion;

  constructor(
    private store: Store<AppState>,
  ) {
    super();
  }

  ngOnInit() {

    this.uxInteractions$.pipe(untilComponentDestroyed(this)).subscribe((data) => {

      this.localUser = {...data.userDetail.user};

      if (this.lastUserId !== this.localUser.userId) {
        if (this.infosForm) {
          this.infosForm.reset();
        }
        this.lastUserId = this.localUser.userId;
      }

      if (!this.infosFormPluged) {
        if (this.infosForm) {

          this.infosForm.statusChanges.pipe(
            untilComponentDestroyed(this),
          ).subscribe(
            status => {
              // console.log(status);
            }
          );

          this.infosForm.valueChanges.pipe(
            untilComponentDestroyed(this)
          ).subscribe(

            newVal => {
              // console.log(newVal);
              // this._store.dispatch(new UpdateUserDetail({ user: newVal }));

            }
          );
          this.infosFormPluged = true;
        }
      }
      // }
    });

  }

  //
  // Actions
  //
  connectAs(userId, action): void {
    this.store.dispatch(ConnectAs({action, userId}));
  }

  saveInfosForm(): void {



    // this.store.dispatch(UpdateUserDetail({user: this.localUser}));

  }

}
